import React, { useEffect, useState } from 'react';
import WholeMeLoadingCircle from 'pages/wholeme/molecules/wholeMeLoadingCircle/WholeMeLoadingCircle';
import ProfileIntakeStepPage from 'pages/wholeme/molecules/profileIntakeStepPage/ProfileIntakeStepPage';
import { usePhotoGallery } from 'hooks/usePhotoGallery';
import PhotoSelector from 'common/molecules/PhotoSelector/PhotoSelector';
import { Stack } from '@mui/material';
// import useFeatureFlags from 'hooks/useFeatureFlags'; //TODO: TEMP commented code, ticket 11312
import { useHistory } from 'react-router-dom';
import { firstValueOf } from '../../../util/profile_util';
import appStrings from '../../../../../common/app_strings';

const { wholeMe: { wholeMePhotoIntake } } = appStrings;

const ProfileIdentityIntakePhotoPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
  isFromGrow,
}) => {
  const history = useHistory();
  const [previewMeta, setPreviewMeta] = useState(null);
  const [showCropCont, setShowCropCont] = useState(false);
  const [blob, setBlob] = useState(null);
  const [working, setWorking] = useState(false);
  // const [isSaveContinueDisabled, setIsSaveContinueDisabled] = useState(false); //TODO: TEMP commented code, ticket 11312
  // const { isSaveAndContinueAlwaysEnabled } = useFeatureFlags();

  // Temporarily disable save logic and enable the button
  // useEffect(() => {
  //   if (isSaveAndContinueAlwaysEnabled) setIsSaveContinueDisabled(false);
  //   else if (blob || previewMeta?.uri) setIsSaveContinueDisabled(false);
  //   else setIsSaveContinueDisabled(true);
  // }, [isSaveAndContinueAlwaysEnabled, blob, previewMeta]);

  const { saveBlobAsMedia } = usePhotoGallery();
  useEffect(() => {
    wholeMeClient.fetchPhotoState().then((state) => {
      setPreviewMeta({
        uri: firstValueOf(state?.profile_image),
      });
    });
  }, []);

  const growHandlerFunc = () => {
    history.push('/tabs/feed');
  };

  const handleNext = () => {
    if (isFromGrow) {
      return growHandlerFunc();
    }
    return nextOnClick();
  };

  const ingressBlob = (blobToUpdate) => {
    setBlob(blobToUpdate);
    setShowCropCont(false);
  };

  const handleSavePhoto = () => {
    if (blob) {
      setWorking(true);
      saveBlobAsMedia(blob).then((result) => {
        wholeMeClient.savePhotoState(result.media.id).then(() => {
          setWorking(false);
          handleNext();
        });
      });
    } else {
      handleNext();
    }
  };

  const setIsCropping = () => {
    setShowCropCont(true);
  };

  return (
    <ProfileIntakeStepPage
      paginationMeta={paginationMeta}
      title={wholeMePhotoIntake.title}
      subtitle={wholeMePhotoIntake.subtitle}
      prevButton={{ onClick: prevOnClick }}
      nextButton={{ onClick: handleSavePhoto }}
      // eslint-disable-next-line
      NavComponent={showCropCont ? <></> : undefined}
      backgroundOverlay="/assets/profile/identity/profile-picture-overlay.svg"
      exitIconOnClickOverride={exitIconOnClickOverride}
      skipPersonalization
    >
      {(!previewMeta) ? (
        <WholeMeLoadingCircle />
      ) : (
        <Stack alignItems="center">
          <PhotoSelector
            previewMeta={previewMeta}
            setBlob={ingressBlob}
            setIsCropping={setIsCropping}
            isWorking={working}
          />
        </Stack>
      )}
    </ProfileIntakeStepPage>
  );
};
export default ProfileIdentityIntakePhotoPage;
